import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("header");
  const navigate = useNavigate();
  const location = useLocation();

  const sectionIds = [
    "header", "features", "about", "services", "partners",
    "loan-service", "our-app", "contact"
  ];

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.6, rootMargin: "-80px 0px -20% 0px" }
    );

    sectionIds.forEach((id) => {
      const element = document.getElementById(id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, []);

  const handleScrollLink = (id) => {
    setIsOpen(false);

    setTimeout(() => {
      const element = document.getElementById(id);
      if (!element) {
        console.warn(`Section #${id} not found!`);
        return;
      }

      const navbarHeight = 85;

      // This is the most reliable method
      element.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

      // Adjust for fixed navbar after scroll starts
      setTimeout(() => {
        const currentScroll = window.pageYOffset;
        window.scrollTo({
          top: currentScroll - navbarHeight,
          behavior: "instant"
        });
      }, 600); // timing depends on scroll duration

      window.history.replaceState(null, "", `#${id}`);
    }, 80);
  };

  // Handle hash in URL (refresh or direct link)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      if (sectionIds.includes(id)) {
        setTimeout(() => handleScrollLink(id), 300);
      }
    }
  }, [location]);

  const handleDashboardClick = () => {
    setIsOpen(false);
    navigate("/login");
  };

  return (
    <nav id="menu" className="navbar navbar-expand-xl navbar-light fixed-top bg-light">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <a
          className="navbar-brand page-scroll d-flex align-items-center"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
            setIsOpen(false);
          }}
        >
          <img
            src="/altrangelogo.png"
            alt="Altrange Logo"
            className="navbar-logo"
          />
          <span className="brand-text">Altrange</span>
        </a>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
        >
          {isOpen ? <span style={{ fontSize: "1.5rem" }}>&times;</span> : <span className="navbar-toggler-icon" />}
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <button
                className={`quote-nav-btn ${location.pathname === "/cement-quote-request" ? "active" : ""
                  }`}
                onClick={() => {
                  setIsOpen(false);
                  navigate("/cement-quote-request");
                }}
              >
                Request today's rate
              </button>
            </li>

            {[
              { id: "features", label: "Features" },
              { id: "about", label: "About" },
              { id: "services", label: "Services" },
              { id: "partners", label: "Our Partners" },
              { id: "loan-service", label: "Loan Service" },
              { id: "our-app", label: "Our App" },
              { id: "contact", label: "Contact" },
            ].map((item) => (
              <li className="nav-item" key={item.id}>
                <button
                  className={`nav-link btn btn-link ${activeSection === item.id ? "active-link" : ""}`}
                  onClick={() => handleScrollLink(item.id)}
                >
                  {item.label}
                </button>
              </li>
            ))}

            <li className="nav-item">
              <button className="dashboard-lnk" onClick={handleDashboardClick}>
                Login Here <span className="arrow">→</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};